// @givmo/app-charity — the CLASS DOOR for a claim in review (CPA-WEB40 · Jonathan, 2026-09-02).
//
// An account with a submitted-but-unapproved claim never enters the console. It stays at the door:
// the onboarding chrome, the claim's status card, and the way to "My claims". The claim-first paths
// (`/claim*`, `/claims*`, `/invites/accept`, `/support`) stay reachable in that chrome; every other
// path replace-redirects here (`org/claim-first-gate.tsx`). `/apps` never shows the pending card.
//
// DATA CONTRACT: `claim-pending-door` (the frame) · `claim-pending-card` + `-note`/`-submitted`/
// `-detail` (the card; was `dashboard-claim-pending`) · `claim-pending-door-claims` (the link).

import { Link } from '@tanstack/react-router';
import { cn, FOCUS_RING, Icon, testIdProp } from '@givmo/design-system';
import { ArrowRight } from 'lucide-react';
import type { CharityClaimRequestOut } from '@givmo/api-client';
import { ClaimPendingCard } from './claim-pending-card';
import { CLAIM_ROUTES } from './claim-routes';

export function ClaimPendingDoor({ claim }: { claim: CharityClaimRequestOut }) {
  return (
    <div
      className="mx-auto flex w-full max-w-[720px] flex-col gap-16 px-24 py-32"
      {...testIdProp('claim-pending-door')}
    >
      <header className="flex flex-col gap-4">
        <h1 className="font-sans text-s20 font-w600 tracking-givmo text-text-strong">
          Your claim is with our team
        </h1>
        <p className="font-sans text-s13 font-w400 leading-h15 tracking-givmo text-text-tertiary">
          This is where its status lives. You’ll get an email the moment it’s decided.
        </p>
      </header>
      <ClaimPendingCard claim={claim} />
      <Link
        to={CLAIM_ROUTES.claims}
        className={cn(
          'inline-flex w-fit items-center gap-6 rounded-md py-2 font-sans text-s13 font-w600 tracking-givmo text-brand-700 outline-none transition-colors hover:text-brand-800',
          FOCUS_RING,
        )}
        {...testIdProp('claim-pending-door-claims')}
      >
        My claims
        <Icon icon={ArrowRight} size={14} aria-hidden />
      </Link>
    </div>
  );
}
